<template>
<page-outline :title="$t('suppliers.kyc_form._label')">
  <template slot="titleContent">
    <span>{{ $t('suppliers.kyc_form._label') }}</span>
    <span style="margin-left:40px;">
      {{
        $t('common.cmpny') + ' : ' +
        currentSupplier.SocialReason
      }}
    </span>
    <span style="margin-left:40px;">
      {{
        $t('common.rprsnttv') + ' : ' +
        currentSupplier.LegalRepresentativeFirstname +
        ' ' +
        currentSupplier.LegalRepresentativeLastname
      }}
    </span>
  </template>
  <template slot="pageContent">
    <div :key="refreshPageContent">
      <!-- <b-row align-h="center" style="margin-bottom:50px;">
        <b-col sm="3" class="form-group"
          v-for="(step, indexStep) in workflow.steps" :key="indexStep">
          <f7-button class="button-action milkyBlockBlack button-tab"
            :active="indexStep === 0" :tab-link="'#tab' + step.id">
            {{ $t('suppliers.kyc_form.' + step.step_label + '._label') }}
          </f7-button>
        </b-col>
      </b-row>
      <f7-tabs animated>
        <f7-tab v-for="(step, indexStep) in workflow.steps" :key="indexStep"
          :id="'tab' + step.id" :active="indexStep === 0">
          <supplier-kyc-form-step :step="step" :seller="currentSupplier"></supplier-kyc-form-step>
        </f7-tab>
      </f7-tabs> -->
      <vue-tabs v-model="tabName"
        active-tab-color="var(--actionButtonColor)"
        active-text-color="var(--actionTextColor)">
        <v-tab v-for="(step, indexStep) in workflow.steps" :key="indexStep"
          :title="step.step_label">
          <div slot="title">
            {{ $t('suppliers.kyc_form.' + step.step_label + '._label') }}
            <span v-if="step.status === 101" class="dot" :style="'background-color:' + getStatusColor(step.status)"></span>
            <span v-else-if="step.status === 102" class="dot" :style="'background-color:' + getStatusColor(step.status)"></span>
            <span v-else-if="step.status === 103" class="dot" :style="'background-color:' + getStatusColor(step.status)"></span>
            <f7-icon class="iconTab" fa="check" v-else-if="step.status === 104" :style="'color:' + getStatusColor(step.status)"></f7-icon>
            <f7-icon class="iconTab" fa="times" v-else-if="step.status === 105" :style="'color:' + getStatusColor(step.status)"></f7-icon>
            <f7-icon class="iconTab" fa="times" v-else-if="step.status === 106" :style="'color:' + getStatusColor(step.status)"></f7-icon>
          </div>
          <supplier-kyc-form-step :step="step" :seller="currentSupplier"
            style="margin-top:30px;">
          </supplier-kyc-form-step>
        </v-tab>
        <!-- <v-tab v-if="!hasFinalStep" title="..." disabled style="color:grey;">
          <div slot="title">
            ...
          </div>
        </v-tab> -->
      </vue-tabs>
    </div>
  </template>
</page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'

import SupplierKYCFormStep from './SupplierKYCFormStep'

import {errorMessageAlert} from '@/helpers/alert'

// import fakeWorkflow from './data/fakeWorkflow.json'

export default {
  name: 'SupplierKYCForm',
  components: {
    'page-outline': PageOutline,
    'supplier-kyc-form-step': SupplierKYCFormStep
  },
  data () {
    return {
      currentSupplier: '',
      hasFinalStep: false,
      refreshPageContent: false,
      tabName: '',
      workflow: {}
    }
  },
  created () {
    this.currentSupplier = this.$engine.services.suppliers.selectedSupplier
    console.log(this.currentSupplier)
    if (this.currentSupplier.Country !== 'FR') {
      this.$i18n.locale = 'en'
    } else {
      this.$i18n.locale = 'fr'
    }

    // this.workflow = fakeWorkflow
    // console.log(this.workflow.steps)

    let that = this
    this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
    this.$engine.services.suppliers.getKYCSteps({
      idSeller: this.currentSupplier.IdSeller
    })
    .then(resp => {
      console.log(resp)
      this.workflow = resp.data
      setTimeout(function () { that.Dom7('.active_tab').click() }, 0)
      if (this.workflow.steps[this.workflow.steps.length - 1].status !== 101) {
        this.hasFinalStep = true
      }
      // this.refreshPageContent = !this.refreshPageContent
      // this.tabName = this.workflow.steps[0].step_label
      this.$f7.hidePreloader()
    })
    .catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })


    this.$bus.$on('decideStep', function (step) {
      that.decideStep(step)
    })
  },
  beforeDestroy () {
    this.$root.$options.i18n.locale = 'fr'
    this.$bus.$off('decideStep')
  },
  methods: {
    decideStep (step) {
      step.idStep = step.id
      step.idExchangeGroup = this.currentSupplier.IdGroupDocument
      let status = step.status

      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      this.$engine.services.suppliers.updateKYCSteps(step)
      .then(resp => {
        this.workflow.steps.find(element => element.id === step.id).status = status
        if (resp.data.steps && resp.data.steps.length) {
          for (let stepIndex in resp.data.steps) {
            let newStep = resp.data.steps[stepIndex]
            this.workflow.steps.push(newStep)
            if (stepIndex === 0) {
              this.tabName = newStep.step_label
            }
          }
        } else {
          this.hasFinalStep = true
        }
        setTimeout(function () { that.Dom7('.active_tab').click() }, 0)

        this.refreshPageContent = !this.refreshPageContent
        this.$f7.hidePreloader()
        if (status === '102') {
          that.$f7.modal({
            title: that.$i18n.t('success.kycstep_saved'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getStatusColor (status) {
      switch (status) {
        case 101:
          return 'grey'
        case 102:
          return 'deepskyblue'
        case 103:
          return 'orange'
        case 104:
          return 'green'
        case 105:
          return 'red'
        case 106:
          return 'orangered'
        default:
          return 'grey'
      }
    }
  }
}
</script>
<style>
/* Override des classes de vue-tabs */
.vue-tabs .nav-tabs {
  border-bottom: 1px solid grey;
}
.vue-tabs .nav-tabs > li > a {
  border: 1px solid gray;
}
.vue-tabs .nav-tabs > li > a:hover {
  border: 1px solid gray;
}
.tab.disabled {
  border: none;
  color: black;
  opacity: 1;
}

i.icon.iconTab {
  margin-top: 14px;
  position: absolute;
}

.dot {
  background-color: grey;
  border-radius: 50%;
  margin-left: 3px;
  margin-top: 18px;
  position: absolute;
  height: 8px;
  width: 8px;
}
.active .dot {
  background-color: var(--actionTextColor);
}
.active .iconTab {
  color: var(--actionTextColor);
}
</style>



// WEBPACK FOOTER //
// SupplierKYCForm.vue?311386d6